// Cookie Consent Message
document.addEventListener("DOMContentLoaded", function () {
  // Function to show a temporary popup message
  function showTemporaryPopup(message, duration = 3000) {
    // Create the popup element
    const popup = document.createElement("div");
    popup.textContent = message;
    popup.className = "cookie-consent-popup fade-in";

    // Add the popup to the body
    document.body.appendChild(popup);

    // Add fade-out animation before removing
    setTimeout(() => {
      popup.classList.remove('fade-in');
      popup.classList.add('fade-out');
    }, duration - 500);

    // Remove the popup after the specified duration
    setTimeout(() => {
      popup.remove();
    }, duration);
  }

  // Function to attach event listeners to both buttons
  function attachButtonListeners() {
    const acceptButton = document.getElementById("shopify-pc__banner__btn-accept");
    const declineButton = document.getElementById("shopify-pc__banner__btn-decline");

    if (acceptButton) {
      acceptButton.addEventListener("click", function () {
        // Show the temporary popup message for "Accept"
        showTemporaryPopup("Thank you for accepting!");
      });
    }

    if (declineButton) {
      declineButton.addEventListener("click", function () {
        // Show the temporary popup message for "Decline"
        showTemporaryPopup("Your preferences have been saved. Thank you!");
      });
    }
  }

  // Use MutationObserver to detect when the cookie popup is injected
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === "childList") {
        // Check if the cookie banner is added to the DOM
        const banner = document.getElementById("shopify-pc__banner");
        if (banner) {
          // Attach the listeners to both buttons
          attachButtonListeners();
          // Stop observing once the banner is found
          observer.disconnect();
        }
      }
    });
  });

  // Start observing the document for changes
  observer.observe(document.body, { childList: true, subtree: true });

}); 